import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActions } from '@auth/store';
import { catchError, map, of, switchMap } from 'rxjs';
import { ParameterActions } from '@features/referentiel/actions/parameter.actions';
import { ParameterService } from '@features/referentiel/services/parameter.service';

@Injectable()
export class ParameterEffects {

  initActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.userProfileLoaded),
      map(() => ParameterActions.getParameters()),
    ),
  );

  loadActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParameterActions.getParameters),
      switchMap(() =>
        this.parameterService.getParameters().pipe(
          map((parametersMap) => {
            const parameters = Object.entries(parametersMap).map(([key, value]) => ({
              id: key,
              key,
              value: value as string,
            }));
            return ParameterActions.getParametersSuccess({ parameters });
          }),
          catchError((error) =>
            of(ParameterActions.getParametersFailure({ errorMessage: error })),
          ),
        ),
      ),
    ),
  );

  constructor(private actions$: Actions, private parameterService: ParameterService) { }

}
